import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=fdfcef1a&"
import script from "./menuItem.ts?vue&type=script&lang=ts&"
export * from "./menuItem.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports